import styled from 'styled-components'
import { Button } from '@sainsburys-tech/bolt'

const AlertLink = styled.a`
  margin-left: 5px;
  text-decoration: underline;
`

const AccordionHeader = styled.div`
  color: ${props => props.theme.color.palette['brand-1']};
`
const AccordionSummaryText = styled.p`
  display: inline-flex;
  color: ${props => props.theme.color.monochrome.darker};
  &&& {
    margin: 0 15px 0 10px;
  }
  font-size: ${props => props.theme.font.size.base};
`
const CustomerQuestionWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  @media only screen and (max-width: ${props => props.theme.size.breakpoint['max-width'].sm}) {
    flex-direction: column;
    width: 100%;
    justify-content: space-around;
  }
`
const AskButtonWrapper = styled.div`
  flex: 1;
  order: 1;
  margin-right: 10px;
  max-width: fit-content;

  @media only screen and (max-width: ${props => props.theme.size.breakpoint['max-width'].sm}) {
    flex: 1;
    order: 3;
    width: inherit;
    max-width: 100%;
    margin-right: 0;
  }
`
const SearchBarWrapper = styled.div`
  flex: 3;
  order: 2;
  margin-right: 10px;
  margin-top: 25px;

  @media only screen and (max-width: ${props => props.theme.size.breakpoint['max-width'].sm}) {
    flex: 1;
    order: 1;
    width: inherit;
    max-width: 100%;
    margin-bottom: 20px;
    margin-right: 0;
  }
`
const SelectBoxWrapper = styled.div`
  flex: 1;
  order: 3;
  margin-right: 1px;

  @media only screen and (max-width: ${props => props.theme.size.breakpoint['max-width'].sm}) {
    flex: 1;
    order: 2;
    width: inherit;
    max-width: 100%;
    margin-bottom: 20px;
  }
`

const StyledButton = styled(Button)`
  @media only screen and (max-width: ${props => props.theme.size.breakpoint['max-width'].sm}) {
    width: 100%;
  }

  ${({ variant, theme }) =>
    variant === 'reviews-container' &&
    `
    color: ${theme.color.palette['brand-1']};
    border: none;
    padding: 0;
    text-decoration: underline;
    pointer-events: none;
  `}
`
const NoQuestionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0;
`
const NoQuestionContent = styled.p`
  padding: 20px 0;
  text-align: center;
`

export {
  AlertLink,
  AccordionHeader,
  AccordionSummaryText,
  CustomerQuestionWrapper,
  AskButtonWrapper,
  SearchBarWrapper,
  SelectBoxWrapper,
  StyledButton,
  NoQuestionWrapper,
  NoQuestionContent
}
